export function htmlToPlainPreviewText(html: string): string {
  if (!html || typeof html !== 'string') return '';
  const withoutTags = html.replace(/<[^>]*>/g, ' ');
  let decoded = withoutTags;
  if (typeof document !== 'undefined') {
    const ta = document.createElement('textarea');
    ta.innerHTML = withoutTags;
    decoded = ta.value;
  } else {
    decoded = withoutTags
      .replace(/&nbsp;/gi, ' ')
      .replace(/&#160;/gi, ' ')
      .replace(/&#x0*a0;/gi, ' ');
  }
  return decoded.replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
}
